<button data-cy="button" matButton="filled" class="mad-danger" [type]="type()" [title]="title()" [disabled]="disabled()">
  <ng-content></ng-content>
</button>
